<ins-add-party
    (cancel)="onCancel()"
    (changeAddress)="onChangeAddress($event)"
    (clearErrors)="onClearErrors()"
    (submitForm)="onSubmit($event)"
    [cityStreet]="cityStreet"
    [countries]="countries$ | async"
    [hasAddressError]="hasAddressError"
    [hasAddressSuccess]="hasAddressSuccess"
    [isCompanyDriver]="isCompanyDriver"
    [notifications]="notifications"
    [role]="role"
></ins-add-party>
